import './Alert.css';

export interface AlertType {
  type: 'error' | 'success';
  message: string;
}

interface AlertProps {
  alert?: AlertType;
}

function Alert({ alert }: AlertProps) {
  if (alert) {
    return <div className={`alert ${alert.type}`}>{alert.message}</div>;
  }
  return null;
}

export default Alert;
